require('./dist/angular-toastr.tpls.js');
module.exports = 'toastr';




/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-toastr/index.js
 ** module id = 129
 ** module chunks = 0
 **/